/* eslint-disable max-len */
import React from "react";

const FooterColumnItem = (props: React.HTMLProps<HTMLAnchorElement>) => {
    const {
        children, ...restProps
    } = props;

    return (
        <li>
            <a {...restProps} rel="noreferrer" target="_blank">{children}</a>
        </li>
    );
};

export { FooterColumnItem as default };
